import { Component, OnInit } from '@angular/core';
import { SpotlightService } from 'src/app/core/services/spotlight.service';

@Component({
  selector: 'app-upcoming-premiere',
  templateUrl: './upcoming-premiere.component.html',
  styleUrls: ['./upcoming-premiere.component.css'],
})
export class UpcomingPremiereComponent implements OnInit {
  premierelist: any;
  spotlightSchedule: any = [];
  upcomingEvent: any;
  userTime: any;
  constructor(private spotlightService: SpotlightService) {}

  ngOnInit(): void {
    // Page run in every second
    this.spotlightService.getData().subscribe((data) => {
        this.premierelist = data;
        this.spotlightService.setIsMotionGraphicsCompleted(false);

        for (let i = 0; i < this.premierelist.length; i++) {
          this.spotlightSchedule =
            this.premierelist[i].cinejoySpotlightsSchedule;
          if (this.spotlightSchedule && this.spotlightSchedule.length) {
            this.premierelist[i].cinejoySpotlightsSchedule = this.premierelist[i].cinejoySpotlightsSchedule.sort(
              (x: any, y: any) =>
                +new Date(x.scheduleTimeText) - +new Date(y.scheduleTimeText)
            );
          }
        }
        this.premierelist = this.premierelist.sort((x: any, y: any) => +new Date(x.cinejoySpotlightsSchedule[0].scheduleTimeText) - +new Date(y.cinejoySpotlightsSchedule[0].scheduleTimeText));
        // Store Upcoming event index 0 into upcomingEvent
        this.upcomingEvent = this.spotlightSchedule[0];
        this.premierelist = this.premierelist.filter((upcoming: any) => {
          return upcoming.cinejoySpotlightsSchedule[upcoming.cinejoySpotlightsSchedule.length - 1].scheduleTimeText > new Date().getTime();
        });
        // Display upcoming 4 events
        this.premierelist = this.premierelist.slice(0, 4);
    });
  }
}
